import { Route, Routes } from "react-router-dom";
import ViewPost from "../../Pages/ViewPost";
import PostList from "./PostList";
const PostsBoard = () => {
    return (
        <Routes>
            <Route path="activity" element={<PostList type="activity" />} />
            <Route path="featured" element={<PostList type="featured" />} />
            <Route path="all" element={<PostList type="all" />} />
            <Route path="discover" element={<div>discover</div>} />
            <Route path="trending" element={<PostList type="featured" />} />
            <Route path="tag/:tag" element={<PostList />} />
            <Route path=":link" element={<ViewPost />} />
        </Routes>
    );
};

export default PostsBoard;
